import { Box, Text } from '@chakra-ui/react';
import { InternalGetIngestionDocumentFragment } from '@client/graphql/__generated__/types';
import { FC, useMemo } from 'react';
import { documentPagePredictionSchema } from './classification.types';
import { ClassificationCompactDisplay } from './index';

interface ClassificationDetailsProps {
  selectedDocument: InternalGetIngestionDocumentFragment | null;
}

export const ClassificationDetails: FC<ClassificationDetailsProps> = ({
  selectedDocument,
}) => {
  const classificationData = useMemo(() => {
    const classification = selectedDocument?.documentML?.documentClassification;
    if (!classification || !Array.isArray(classification)) {
      return [];
    }

    return classification
      .map((item) => documentPagePredictionSchema.safeParse(item))
      .filter((result) => result.success)
      .map((result) => result.data);
  }, [selectedDocument?.documentML?.documentClassification]);

  if (!classificationData.length) {
    return (
      <Box p={3}>
        <Text color="compliance.text.muted" fontSize="sm" fontWeight="medium">
          No classification data available for this document
        </Text>
      </Box>
    );
  }

  return (
    <ClassificationCompactDisplay
      classification={classificationData}
      ingestionDocument={selectedDocument || undefined}
    />
  );
};
